

define(['squid/index', './directive', 'components/xo-address-components/src/address-normalization/route', 'components/xo-address-components/src/add-address/directive', '../shipping-address/directive'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-update-shipping.route', ['squid', 'xo-shipping-address.directive', 'xo-add-address.directive', 'xo-address-normalization.route']).factory('$UpdateShippingRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('UpdateShippingRoute', {
            name: 'updateShipping',
            directive: 'xo-update-shipping',
            titleContent: 'addShipping.addAddress',
            trackingData: {
                fptiState: 'update_shipping',
                buzname: {
                    'fullpage': {
                        'pagename': '%::update_shipping',
                        'pagename2': '%::update_shipping:member:hermes:',
                        'version': 'member:%:'
                    }
                }
            },
            loginRequired: true,
            children: [{
                name: '$AddressNormalizationRoute',
                attributes: {
                    id: 'token',
                    sidebar: 'sidebar',
                    address: 'address',
                    'done-fn': 'uponNormalization'
                }
            }]
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/select-shipping/update-shipping/route.js
// module id = ./components/xo-member-components/src/select-shipping/update-shipping/route.js
// module chunks = 1